

import React, { Component } from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import withAuth from '../../components/withAuth';
import { getCurrentFunctionName } from '../../performanceModeManager';
import CustomizedTextField from '../Input/CustomizedTextField';
import { formatInvoicingMode } from '../../redux/affair/affairTypes';

class ContractAdditionnalFields extends Component {

    constructor(props) {
        super(props);

        if (!props.affair)
            props.history.push("/affairs");
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        if (!this.props.affair)
            return null;

        return (
            <div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 control-margin-top">
                    <CustomizedTextField
                        id="invoice-count"
                        label="Nombre de factures prévues au contrat"
                        className="full_size light-disabled"
                        value={this.props.affair.invoice_count}
                        margin="normal"
                    />
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 control-margin-top">
                    <CustomizedTextField
                        id="inspection-count"
                        label="Nombre de visite"
                        className="full_size light-disabled"
                        value={this.props.affair.inspection_count}
                        margin="normal"
                    />
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 control-margin-top">
                    <CustomizedTextField
                        id="invoicing-mode"
                        label="Mode de facturation"
                        className="full_size light-disabled"
                        value={formatInvoicingMode(this.props.affair.invoicing_mode)}
                        margin="normal"
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        affair: state.affair.currentAffair,
    };
};

const mapDispatchToProps = () => {
    return {
    };
};

export default compose(withAuth, withRouter, connect(mapStateToProps, mapDispatchToProps))(ContractAdditionnalFields);
